import type { SessionData } from "@productlane/auth"
import type { ZeroJwtPayload } from "@productlane/lib/src/browser"
import { isImpersonationReadOnly } from "@productlane/lib/src/impersonation"

// A cached token only fits when it was minted for this user, this workspace and
// this impersonation write mode; otherwise the push guard would see stale claims.
export function canReuseZeroToken(
	decoded: ZeroJwtPayload,
	session: Pick<
		SessionData,
		| "workspaceId"
		| "userId"
		| "impersonatingFromUserId"
		| "impersonationWritesAllowed"
	>,
) {
	return (
		decoded.workspaceId === session.workspaceId &&
		decoded.userId === session.userId &&
		!!decoded.readOnly === isImpersonationReadOnly(session)
	)
}
